import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/vendors/simple-line-icons/css/simple-line-icons.css";
import "./assets/css/style.css";
import { CookiesProvider } from "react-cookie";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Handle redirect promise on load so MSAL doesn't throw hash_empty_error
  // when the user lands on /login with no hash (e.g. after session expiry).
  return msalInstance.handleRedirectPromise().catch(() => null);
}).then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  // When we're in the MSAL popup with a hash (Azure redirect callback), don't mount the full app:
  // the Router would Navigate to /login and strip the hash, causing hash_empty_error. Show minimal
  // "Completing sign in..." so MSAL can finish and close the popup.
  const isPopupWithHash = typeof window !== 'undefined' && window.opener && window.location.hash;
  if (isPopupWithHash) {
    root.render(
      <div style={{ padding: '20px', fontFamily: 'sans-serif', textAlign: 'center' }}>
        Completing sign in...
      </div>
    );
    return;
  }

  const Index = () => {
    return (
      <Router>
        <CookiesProvider>
          <App msalInstance={msalInstance} />
          <ToastContainer position="top-right" autoClose={2000} />
        </CookiesProvider>
      </Router>
    );
  };

  root.render(<Index />);
}).catch(err => {
  console.error("MSAL initialization failed:", err);
});